import React, { useState } from 'react';
import { Mic } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { VoiceRecorder } from './VoiceRecorder';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';

interface VoiceButtonProps {
  onVoiceCapture: (file: File) => Promise<void>;
  disabled?: boolean;
}

export const VoiceButton: React.FC<VoiceButtonProps> = ({
  onVoiceCapture,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleVoiceCapture = async (file: File) => {
    await onVoiceCapture(file);
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          size="sm"
          disabled={disabled}
          className="bg-orange-500 hover:bg-orange-600 text-white border-0 text-xs"
        >
          <Mic className="h-4 w-4 mr-1" />
          Voice Note
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <VoiceRecorder onVoiceCapture={handleVoiceCapture} disabled={disabled} />
      </DialogContent>
    </Dialog>
  );
};